<template>
	<div class="main" v-title data-title="零部件收藏记录">
		<iHeader ref="loginIndex"></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">收藏记录</h1>
					</div>
				</div>
				<div class="formW">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane label="产品" name="first">
							<el-row :gutter="20">
								<el-col :span="6" style="margin-top: 10px;">
									<div class="grid-content collbox" style="height: 203px;">
										<el-button type="text" @click="newFavoriteshow()">
											<img src="../../assets/add.jpg" class="img" alt="">
											<p class="mt10">新建收藏夹</p>
										</el-button>
									</div>
								</el-col>
								<el-col :span="6" v-for="(item,index) in collectlistdata" :key='index' style="margin-top: 10px;">
									<div class="grid-content collbox">
										<div class="imgbox" @click="jumpurl(item.id)">
											<img src="../../assets/img1.jpg" class="img" alt="">
											<img src="../../assets/img1.jpg" class="img" alt="">
											<img src="../../assets/img1.jpg" class="img" alt="">
											<img src="../../assets/img1.jpg" class="img" alt="">
										</div>
										<el-dropdown class="position" v-show="item.id!=0">
											<div class="el-dropdown-link edit-samllbtn"></div>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item @click.native='newFavoriteshow(item.id)'>编辑收藏夹</el-dropdown-item>
												<el-dropdown-item @click.native="del(item.id)">删除</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
										<p class="favname" @click="jumpurl(item.id)">{{item.name}}</p>
										<p class="favdoc">收藏夹 ( <i class="el-icon-picture-outline"></i> {{item.count}} ) </p>
									</div>
								</el-col>
								<!-- <el-col :span="6" >
                  <div class="grid-content collbox">
                    <div class="imgbox">
                      <img src="../../assets/img1.jpg" class="img" alt="">
                      <img src="../../assets/img1.jpg" class="img" alt="">
                      <img src="../../assets/img1.jpg" class="img" alt="">
                      <img src="../../assets/img1.jpg" class="img" alt="">
                    </div>
                    <p class="favname">收藏夹name</p>
                    <p class="favdoc">收藏夹 (<i class="el-icon-picture-outline"></i> 14 ) </p>
                  </div>
                </el-col> -->
							</el-row>
							<!-- <div class="block pdb10 " style="float: right">
								<el-pagination @current-change="handleCurrentChange" @size-change="handSizeChange" :current-page.sync="page"
								 :page-sizes="[12, 24, 36]" :page-size="100" layout="prev, pager, next,sizes,total" :total='total'>
								</el-pagination>
							</div> -->
						</el-tab-pane>
						<el-tab-pane label="供应商" name="second">
							<div v-if="tableData.length==0" class="txc">暂无数据 </div>
							<div v-else>
								<el-table :data="tableData" border style="width: 100%">
									<el-table-column prop="province" label="产品名" width="300">
									</el-table-column>
									<el-table-column prop="address" label="型号" width="300">
									</el-table-column>
									<el-table-column prop="name" label="供应商/品牌" width="120">
									</el-table-column>
									<el-table-column prop="cardid" label="询价单号" width="120">
									</el-table-column>
									<el-table-column prop="id" label="模型下载" width="120">
									</el-table-column>
									<el-table-column fixed="right" label="操作" width="100">
										<template slot-scope="scope">
											<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<v-footer></v-footer>

		<el-dialog title="创建文件夹" :visible.sync="dialogFormVisible">
			<el-form :model="form">
				<el-form-item label="收藏夹名称: " :label-width="formLabelWidth">
					<el-input type="input" v-model="form.collectname" placeholder="收藏夹名称(必填)" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="收藏夹描述:" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="form.collectdoc" placeholder="简介" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="newFavorite">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import VDistpicker from 'v-distpicker'
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
			VDistpicker,
			vnav,
		},
		data() {
			return {
				collectlistdata: [],
				activeName: 'first',
				dialogFormVisible: false,
				favorite_id: '',
				page: 1,
				pcount: 1,
				total: 1,
				formLabelWidth: '100px',
				form: {
					collectname: '',
					collectdoc: '',
					id: '',
					date: '',
					status: '',
					xinghao: '',
					name: ''
				},
				titleDec: "",
				tableData: []
			};
		},
		created() {
			this.collectlist();
		},
		methods: {
			newFavoriteshow(id) {
				this.dialogFormVisible = true;
				this.favorite_id = id;
				this.$postcn('partshome/loadFavorite', {
					'favorite_id': this.favorite_id
				}, this).then((res) => {
					if (res.data.code == 200) {
						this.form.collectname = res.data.data.name;
						this.form.collectdoc = res.data.data.describe;
					}
				})
			},
			newFavorite() {
				this.$postcn('partshome/newFavorite', {
					'favorite_id': this.favorite_id,
					'name': this.form.collectname,
					'describe': this.form.collectdoc
				}, this).then((res) => {
					//console.log(res);
					if (res.data.code == 200) {
						this.dialogFormVisible = false
						this.$message({
							type: 'success',
							message: res.data.msg
						});
						this.collectlist();
					} else {
						this.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				})
			},
			collectlist() {
				this.$postcn('partshome/favoriteList', {
				}, this).then((res) => {
					//console.log(res);
					if (res.data.code == 200 && res.data.code!=-4004) {
						this.collectlistdata = res.data.data;
						this.total = res.data.count;
						//console.log(this.total);
					}else if(res.data.code==-4004){
						this.$refs.loginIndex.handLogin(window.location.href)
					}else{
						this.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				})
			},
			handleCurrentChange(val) {
				this.page = val;
				this.collectlist()
			},
			handSizeChange(val) {
				this.pcount = val;
				this.collectlist()
			},
			jumpurl(id) {
				//console.log(id);
				let routeData = this.$router.resolve({
					path: "collectiondetail",
					query: {
						favorite_id: id
					}
				})
				window.open(routeData.href, '_blank');
			},
			del(id) {
				this.$confirm('确定要删除该收藏夹吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 调取接口
					this.$postcn('partshome/delFavorite', {
						'favorite_id': id
					}, this).then((res) => {
						if (res.data.code == 200) {
							this.collectlist();
							this.$refs.loginIndex.colnum=res.data.data
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			handleClick(row) {
				// console.log(row);
			},
			onSubmit() {
				// console.log('submit!');
			}
		}
	}
</script>

<style style="scoped">
	.mt10 {
		margin-top: 10px;
	}

	.el-input__inner {
		padding: 0 15px;
	}

	/* .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  } */

	/*  .el-col {
    border-radius: 4px;
    margin-bottom: 15px;
  } */

	.bg-purple-dark {
		background: #99a9bf;
	}

	.bg-purple {
		background: #d3dce6;
	}

	.bg-purple-light {
		background: #e5e9f2;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	}

	.collbox {
		position: relative;
		background-color: #F3F3F3;
		padding: 10px;
		line-height: 1.3;
		text-align: center;
	}

	.imgbox {
		width: 230px;
		height: 160px;
	}

	.imgbox:hover,
	.favname:hover {
		cursor: pointer;
	}

	.imgbox .img {
		width: 115px;
		height: 80px;
		float: left;
	}

	.favname {
		line-height: 25px;
		text-align: left;
		font-size: 14px;
	}

	.favdoc {
		color: #9e9e9e;
		text-align: left;
		font-size: 14px;
	}

	.item1 {
		display: inline-block;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.formW {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.inputW {
		width: 200PX;
	}

	.el-input--mini .el-input__inner {
		line-height: 38PX !important;
		height: 38PX !important;
		padding-left: 10PX;
		width: 150PX;
	}

	.el-form-item {
		margin-bottom: 22px;
		width: 80%;
		display: inline-block;
	}

	.collbox .el-button {
		padding: 3px 20px !important;
	}

	.position {
		position: absolute;
		right: 10px;
		top: 10px;
	}

	.edit-samllbtn {
		min-width: 34px;
		height: 22px;
		line-height: 22px;
		color: #fff;
		text-align: center;
		background: url(../../assets/gengduo.svg);
		border-radius: 0 2px;
		cursor: pointer;
		float: left;
	}

	.el-pagination .el-select .el-input .el-input__inner {
		padding-right: 25px;
		border-radius: 3px;
		height: 25px !important;
		line-height: 25px !important;
		width: 100px !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/collection.vue